/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type StatEngineTable_query$ref: FragmentReference;
declare export opaque type StatEngineTable_query$fragmentType: StatEngineTable_query$ref;
export type StatEngineTable_query = {|
  +nflPlayerWeekStats: ?{|
    +headers: ?$ReadOnlyArray<?{|
      +Header: ?string,
      +accessor: ?string,
    |}>,
    +rows: ?{|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +player: ?{|
            +firstName: string,
            +lastName: string,
            +position: {|
              +name: ?string
            |},
            +dkPlayer: ?{|
              +id: string
            |},
            +injuryStatus: ?string,
            +team: ?{|
              +id: string,
              +abbreviation: string,
            |},
          |},
          +stats: ?any,
        |}
      |}>
    |},
  |},
  +$refType: StatEngineTable_query$ref,
|};
export type StatEngineTable_query$data = StatEngineTable_query;
export type StatEngineTable_query$key = {
  +$data?: StatEngineTable_query$data,
  +$fragmentRefs: StatEngineTable_query$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  "nflPlayerWeekStats",
  "rows"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 1000,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "endWeek"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "positions"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "seasonID"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sortBy"
    },
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "startWeek"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "weeks"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./NFLStatEnginePaginationQuery.graphql.js')
    }
  },
  "name": "StatEngineTable_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "endWeek",
          "variableName": "endWeek"
        },
        {
          "kind": "Variable",
          "name": "positions",
          "variableName": "positions"
        },
        {
          "kind": "Variable",
          "name": "seasonId",
          "variableName": "seasonID"
        },
        {
          "kind": "Variable",
          "name": "sortBy",
          "variableName": "sortBy"
        },
        {
          "kind": "Variable",
          "name": "startWeek",
          "variableName": "startWeek"
        },
        {
          "kind": "Variable",
          "name": "weeks",
          "variableName": "weeks"
        }
      ],
      "concreteType": "NFLStatDataType",
      "kind": "LinkedField",
      "name": "nflPlayerWeekStats",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NFLStatDataHeader",
          "kind": "LinkedField",
          "name": "headers",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "Header",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accessor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "rows",
          "args": null,
          "concreteType": "NFLStatDataRowConnection",
          "kind": "LinkedField",
          "name": "__StatTable_rows_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NFLStatDataRowEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NFLStatDataRowType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NFLStatPlayerType",
                      "kind": "LinkedField",
                      "name": "player",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "NFLStatPositionType",
                          "kind": "LinkedField",
                          "name": "position",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "name",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "PlayerType",
                          "kind": "LinkedField",
                          "name": "dkPlayer",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "injuryStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "NFLStatTeamType",
                          "kind": "LinkedField",
                          "name": "team",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "abbreviation",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "stats",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b2f85255e04ff7b93c55636e13729c1e';

module.exports = node;
